import { spItemKeyFacet } from '../Keys';
import ISPGetItemResponse from '@ms/odsp-datasources/lib/dataSources/item/spListItemRetriever/interfaces/ISPGetItemResponse';
import { IItemCacheThunkAction, IItemCacheDispatch } from '@ms/items-view/lib/private/store/actions/ItemCacheActions';
import ListTemplateType from '@ms/odsp-datasources/lib/dataSources/listCollection/ListTemplateType';
import strings from '../SPOFiles.resx';
import { getLeafFolderIndex } from '../../utilities/path/getLeafFolderIndex';

export function getFolderName(payload: {
  key: typeof spItemKeyFacet.type;
  serverData: ISPGetItemResponse
}): IItemCacheThunkAction<string | undefined> {
  return (dispatch: IItemCacheDispatch) => {
    const {
      listFullUrl,
      itemId,
      rootFolder
    } = payload.key;
    const {
      ListTitle: listTitle,
      ListTemplateType: listTemplateTypeString
    } = payload.serverData;

    let folderName: string | undefined;

    if (!itemId && !rootFolder) {
      // Show list title as folder name if rootFolder and itemId is empty for all non-ODB lists.
      const isODB = typeof listTemplateTypeString === 'string' && Number(listTemplateTypeString) === ListTemplateType.mySiteDocumentLibrary;

      if (isODB) {
        folderName = strings.files;
      } else {
        folderName = listTitle;
      }
    } else if (rootFolder) {
      const leafFolderIndex = getLeafFolderIndex(rootFolder, listFullUrl);
      if (leafFolderIndex > -1) {
        folderName = rootFolder.substring(leafFolderIndex + 1);
      }
    }

    return folderName;
  };
}
